import React from 'react';
import { Alert, Text } from '@cochlear-design-system/foundation';

const CaseCreationSuccessAlert = ({ caseNumber, labels }) => {
  return (
    <Alert
      variant="success"
      heading={
        labels['labels.reportLoanerIssue.sendRequest.successTitle']
      }
    >
      <Text
        content={
          labels['labels.reportLoanerIssue.sendRequest.successMsg1']
        }
        type="body-text"
      />
      <Text
        content={(
          labels[
            'labels.reportLoanerIssue.sendRequest.successMsg2'
          ] || ''
        ).replace('{{CaseNumber}}', caseNumber || '')}
        type="body-text"
      />
    </Alert>
  );
};

export default CaseCreationSuccessAlert;
